module.exports = __webpack_public_path__ + "img/ctrip.997df3cf.png";